import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4363bde2&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4363bde2')) {
      api.createRecord('4363bde2', component.options)
    } else {
      api.reload('4363bde2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4363bde2&", function () {
      api.rerender('4363bde2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/SizeSelect/index.vue"
export default component.exports